import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const ZdChatHide = ({
  height = "28",
  width = "28",
  fill = theme.colors["maya-blue"],
  stroke = theme.colors.white,
}: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill={fill} />
      <rect x="4" y="7.69794" width="20" height="10" rx="5" fill={stroke} />
      <path d="M19.9998 23.0396L16.0397 19L20.0048 19.0394L19.9998 23.0396Z" fill={stroke} />
      <rect x="6" y="20.5456" width="22" height="1.5" rx="0.75" transform="rotate(-44.9603 6 20.5456)" fill={stroke} />
      <rect
        x="5.14624"
        y="19.2788"
        width="20"
        height="1.5"
        rx="0.75"
        transform="rotate(-44.9603 5.14624 19.2788)"
        fill={fill}
      />
    </svg>
  );
};
export default ZdChatHide;
